import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_RAD_CHECK_PERMISSIONS = [
  PermissionsEnum.api_view_radius,
  PermissionsEnum.api_add_radius,
];
